/** @format */

import { action } from 'easy-peasy';

const HeaderModel = {
	HamburgerExpanded: false,
	UserExpanded: false,
	toggleHamburger: action((state) => {
		state.HamburgerExpanded = !state.HamburgerExpanded;
		state.UserExpanded = false;
	}),
	toggleUser: action((state) => {
		state.UserExpanded = !state.UserExpanded;
		state.HamburgerExpanded = false;
	}),
};

export default HeaderModel;
